module.exports = __webpack_public_path__ + "img/O_TalkBeforeAction.4c79e403.gif";